var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"battery-mock"},[_c('div',{staticClass:"cap"}),_c('div',{staticClass:"battery-body"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.batteryState)+"% ")]),_c('div',{staticClass:"scale",style:(`width: ${_vm.batteryState}%`)})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }